import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=ebb34716&scoped=true"
import script from "./Settings.js?vue&type=script&lang=js&external"
export * from "./Settings.js?vue&type=script&lang=js&external"
import style0 from "./Settings.vue?vue&type=style&index=0&id=ebb34716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb34716",
  null
  
)

export default component.exports